import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from './ui/button';

const DeleteConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, loading }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-end justify-center bg-black/80 backdrop-blur-sm sm:items-center sm:p-6"
          onClick={onClose}
        >
          <motion.div
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 40, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 400, damping: 36 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md rounded-t-3xl border border-[#f43f5e]/50 bg-[#18181b] p-6 pb-safe sm:rounded-3xl sm:p-8"
            data-testid="delete-confirm-dialog"
          >
            <button
              onClick={onClose}
              disabled={loading}
              className="absolute top-4 right-4 text-[#a1a1aa] hover:text-white transition-colors"
            >
              <X className="w-6 h-6" />
            </button>

            <div className="flex justify-center mb-4">
              <div className="bg-[#f43f5e]/20 p-4 rounded-2xl">
                <AlertTriangle className="w-12 h-12 text-[#f43f5e]" />
              </div>
            </div>

            <h2 className="mb-2 text-center font-heading text-xl font-semibold text-white sm:text-2xl">
              {title}
            </h2>
            <p className="mb-6 text-center text-sm leading-relaxed text-[#a1a1aa]">
              {message}
            </p>

            <div className="flex gap-3">
              <Button
                onClick={onClose}
                disabled={loading}
                variant="outline"
                className="h-12 flex-1 rounded-full border-white/[0.1] text-white hover:bg-white/[0.06]"
              >
                Cancel
              </Button>
              <Button
                onClick={onConfirm}
                disabled={loading}
                data-testid="confirm-delete-btn"
                className="h-12 flex-1 rounded-full bg-[#f43f5e] font-semibold text-white hover:bg-[#dc2626]"
              >
                {loading ? 'Deleting...' : 'Delete'}
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DeleteConfirmDialog;
